import { create } from "zustand";

interface ScreenHeight {
  height: number;
  setHeight: (height: number) => void;
}

export const useScreenHeight = create<ScreenHeight>((set) => ({
  height: window.innerHeight,
  setHeight: (height) => set({ height }),
}));
